import { DecisionReason, HackleRemoteConfig, RemoteConfigDecision, User } from "../../core/internal/model/model"
import HackleCore from "../../core/HackleCore"
import { HackleUserResolver } from "../user/index.node"
import ObjectUtil from "../../core/internal/util/ObjectUtil"
import Logger from "../../core/internal/logger"
import { TimerSample } from "../../core/internal/metrics/Timer"
import HackleRemoteConfigDecider from "./HackleRemoteConfigDecider"
import { DecisionMetrics } from "../../core/internal/metrics/monitoring/MonitoringMetricRegistry"

const log = Logger.log

export default class HackleRemoteConfigImpl implements HackleRemoteConfig {
  constructor(
    private readonly core: HackleCore,
    private readonly hackleUserResolver: HackleUserResolver,
    private readonly user: User
  ) {}

  get(key: string, defaultValue: string): string
  get(key: string, defaultValue: number): number
  get(key: string, defaultValue: boolean): boolean
  get(key: string, defaultValue: string | number | boolean): string | number | boolean {
    const sample = TimerSample.start()
    let decision: RemoteConfigDecision
    try {
      decision = this.decide(key, defaultValue)
    } catch (e) {
      log.error(`Unexpected exception while deciding remote config parameter[${key}]. Returning default value. : ${e}`)
      decision = RemoteConfigDecision.of(defaultValue, DecisionReason.EXCEPTION)
    }
    DecisionMetrics.remoteConfig(sample, key, decision)
    return decision.value
  }

  private decide(key: string, defaultValue: string | number | boolean): RemoteConfigDecision {
    const hackleUser = this.hackleUserResolver.resolveOrNull(this.user)
    if (ObjectUtil.isNullOrUndefined(hackleUser)) {
      return RemoteConfigDecision.of(defaultValue, DecisionReason.INVALID_INPUT)
    }
    return HackleRemoteConfigDecider.decide(this.core, key, defaultValue, hackleUser)
  }
}
